import { css } from 'styled-components';

import { getFontFormatURLs } from './fonts';
import {
  responsiveBodyMD,
  responsiveBodySM,
  responsiveBodyXS,
  responsiveHeadingLG,
  responsiveHeadingMD,
  responsiveHeadingSM,
  responsiveHeadingXL,
  responsiveHeadingXS,
} from './responsiveFontSizes';
import type { Theme } from 'client-ribbons-base/types/theme';

export const theme: Theme = {
  responsiveText: {
    HEADING: {
      XL: responsiveHeadingXL,
      LG: responsiveHeadingLG,
      MD: responsiveHeadingMD,
      SM: responsiveHeadingSM,
      XS: responsiveHeadingXS,
    },
    BODY: {
      MD: responsiveBodyMD,
      SM: responsiveBodySM,
      XS: responsiveBodyXS,
    },
  },
  fonts: {
    PRIMARY_REGULAR: {
      family: 'NOTHS Sans No3',
      weight: 'normal',
      formats: getFontFormatURLs('fonts/noths_sans_3_regular'),
    },
    PRIMARY_SEMIBOLD: {
      family: 'NOTHS Sans No3',
      weight: '600',
      formats: getFontFormatURLs('fonts/noths_sans_3_semibold'),
    },
    SECONDARY_REGULAR: {
      family: 'NOTHS Sans No2',
      weight: 'normal',
      formats: getFontFormatURLs('fonts/noths_sans_2_regular'),
    },
    SECONDARY_SEMIBOLD: {
      family: 'NOTHS Sans No2',
      weight: '600',
      formats: getFontFormatURLs('fonts/noths_sans_2_semibold'),
    },
  },
  spacing: {
    base: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 48,
    xxxxl: 64,
  },
} as const;

export const primaryRegularFont = css`
  font-family: ${theme.fonts.PRIMARY_REGULAR.family};
  font-weight: ${theme.fonts.PRIMARY_REGULAR.weight};
`;

export const primarySemiBoldFont = css`
  font-family: ${theme.fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${theme.fonts.PRIMARY_SEMIBOLD.weight};
`;
